<template>
    <div class="dailyDanger">
        <MyTransition :myName="'up'">
            <div class="paper_popup" v-if="popupStatus && popup == 'sign'">
                <div class="flex flex_end close">
                    <button class="icon_btn btn_primary" @click="closeSign">
                        <i class="el-icon-close"></i>
                    </button>
                </div>
                <Popup>
                    <Sign :sign_name="sign_name" :index="sign_index" @transfromIMG="transfromIMG"></Sign>
                </Popup>
            </div>
        </MyTransition>
        <MyTransition :myName="'up'">
            <Popup v-if="popupStatus && popup !== 'sign'">
                <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
                <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
            </Popup>
        </MyTransition>
        <div ref="html_child">
            <div class="form_input flex">
                <label> 表單號碼 </label>
                <div class="flex">
                    {{ options.application.form_id }}
                </div>
            </div>
            <div class="form_input flex">
                <label> 原事業單位名稱 </label>
                <div>錼創顯示科技股份有限公司</div>
            </div>
            <div class="form_input flex" v-if="!id">
                <label> 施工日期 </label>
                <div class="time_range flex">
                    {{ $moment().format("YYYY-MM-DD") }}
                </div>
            </div>
            <div class="form_input flex" v-else>
                <label> 表單日期 </label>
                <div class="time_range flex">
                    {{ this.$moment(allData["date"]).format("YYYY-MM-DD") }}
                </div>
            </div>
            <div class="form_input flex">
                <label>作業名稱</label>
                <!-- {{workData.application.name}} -->
                <div class="width_220">
                    {{ formInput.name }}
                    <!-- <el-select
            value-key="id"
            v-model="workData"
            :placeholder="id ? workData.application.name : '請選擇'"
            :disabled="id !== null"
            @change="handlerID"
          >
            <el-option
              v-for="item in options.application"
              :key="item.id"
              :label="`${item.form_id}_${item.vendor.vendor_chinese}_${item.application.name}`"
              :value="item"
            ></el-option>
          </el-select> -->
                </div>
            </div>
            <div class="form_input flex">
                <label>施工區域</label>
                <div>
                    <p v-for="(area, i) in formInput.area" :key="i">
                        {{ area }}
                    </p>
                </div>
            </div>
            <div class="form_input flex">
                <label>工作場所負責人</label>
                <div>
                    <div>
                        {{ formInput.employee_sign }}
                    </div>
                </div>
            </div>
            <div class="form_input flex">
                <label>承攬商</label>
                <div>
                    <div v-for="(vendor, i) in formInput.vendor" :key="i">
                        {{ vendor }}
                    </div>
                </div>
            </div>
            <div class="form_input flex">
                <label>特殊作業項目</label>
                <div v-if="formInput.op_id.length !== 0">
                    <div v-for="(op, index) in formInput.op_id" :key="index">
                        {{ op }}
                    </div>
                </div>
                <div v-else>無特殊作業項目</div>
            </div>
            <!---下面用是否有id來判斷是新增還是瀏覽，如果有id代表是瀏覽狀態---->
            <!--New施工單以取消多次更新此表單-->
            <!-- <div class="multi_navigation flex" v-if="id">
                <div
                    :class="multi_navigation_check == index ? 'check' : false"
                    class="item"
                    v-for="(date, index) in allData"
                    :key="index"
                    @click="workDate(date, index)"
                >
                    {{ date.updated_at }}
                </div>
            </div> -->
            <template>
                <!--會議決策--->
                <div class="form_input">
                    <label>會議決議事項</label>
                    <div class="commit_textarea" v-if="id">
                        <div class="commit_textarea_item">
                            <div>依安全作業標準執行作業</div>
                            {{ allData.commit_content }}
                        </div>
                    </div>
                    <div class="commit_textarea" v-else>
                        <div>依安全作業標準執行作業</div>
                        <textarea class="input_primary" v-model="formInput.commit_content">
                        </textarea>
                    </div>
                </div>
                <!--危害告知--->
                <div class="form_input flex" id="danger_list">
                    <label>危害告知<span>（必填項目）</span></label>
                    <div class="special_option">
                        <p>本作業包括但不限於以下危害</p>
                        <template v-if="id">
                            <el-checkbox-group v-model="allData.danger_list">
                                <el-checkbox v-for="(item, i) in info" :key="i" :label="item" disabled></el-checkbox>
                            </el-checkbox-group>
                            <div v-if="allData.danger_list !== null">
                                <input v-if="allData.danger_list.includes(
            '其他潛在危害'
        )
            " type="text" disabled v-model="allData.danger_list_other" />
                            </div>
                        </template>
                        <template v-else>
                            <el-checkbox-group v-model="formInput.danger_list">
                                <el-checkbox v-for="(item, i) in info" :key="i" :label="item"></el-checkbox>
                            </el-checkbox-group>
                            <!-- && allData.danger_list != null -->
                            <input v-if="formInput.danger_list.includes(
            '其他潛在危害'
        )
            " type="text" v-model="formInput.danger_list_other" />
                        </template>
                    </div>
                </div>
                <!--防護器具--->
                <div class="form_input flex" id="protection_list">
                    <label>防護器具<span>（必填項目）</span></label>
                    <div class="special_option">
                        <template v-if="id">
                            <el-checkbox-group v-model="allData.protection_list">
                                <el-checkbox v-for="(item, i) in tools" :key="i" :label="item" disabled></el-checkbox>
                            </el-checkbox-group>
                            <div v-if="allData.protection_list !== null">
                                <input v-if="allData.protection_list.includes('其他')
            " type="text" disabled v-model="allData.protection_list_other" />
                            </div>
                        </template>
                        <template v-else>
                            <el-checkbox-group v-model="formInput.protection_list">
                                <el-checkbox v-for="(item, i) in tools" :key="i" :label="item"></el-checkbox>
                            </el-checkbox-group>
                            <input v-if="formInput.protection_list.includes('其他')
            " type="text" v-model="formInput.protection_list_other" />
                        </template>
                    </div>
                </div>
                <!---危害因素--->
                <div class="form_input flex">
                    <label>危害因素</label>
                    <div class="special_option">
                        <template v-if="id">
                            <el-checkbox-group v-model="allData.danger_elemnet">
                                <div v-for="(item, index) in options.op_descript" :key="index">
                                    <el-checkbox disabled class="checkbox_item" :label="item.op_name" :key="index">
                                        <h1>{{ item.op_name }}</h1>
                                        <div class="descript">
                                            <div>{{ item.descript }}</div>
                                            <div v-for="(
                                                    notice, i
                                                ) in item.notice" :key="i">
                                                {{ notice }}
                                            </div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </template>
                        <template v-else>
                            <el-checkbox-group v-model="formInput.danger_elemnet">
                                <div v-for="(item, index) in options.op_descript" :key="index">
                                    <el-checkbox class="checkbox_item" :label="item.op_name" :key="index">
                                        <h1>{{ item.op_name }}</h1>
                                        <div class="descript">
                                            <div>{{ item.descript }}</div>
                                            <div v-for="(
                                                    notice, i
                                                ) in item.notice" :key="i">
                                                {{ notice }}
                                            </div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </template>
                    </div>
                </div>
                <!--條款項目-->
                <div class="commit_content">
                    <div v-for="(item, index) in commitItem" :key="index">
                        {{ index + 1 }}. {{ item }}
                    </div>
                </div>
                <!--簽名-->
                <div class="form_input">
                    <!-- <label>施工人員簽名</label> -->
                    <template>
                        <div class="sign_list">
                            <label>現場監工人員</label>
                            <div class="sign_item  flex_column">
                                <div class="flex flex_align_baseline flex_align_center"
                                    v-for="(vendor, index) in formInput.vendors" :key="index">
                                    <div class="sign_name">
                                        {{ formInput.vendor[index] }} /
                                        {{ vendor.supervisor.name }}
                                    </div>
                                    <div class="sign_btn">
                                        <img :src="showImg('vendor_sign', index)" alt="" />

                                        <button v-if="!id &&
            !disabledBtn.vendor_sign[index]
            " class="btn_primary" @click="
            openSign({
                key: 'vendor_sign',
                index: index,
            })
            ">
                                            簽名
                                        </button>
                                        <span v-else></span>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label>工程承辦人員</label>
                                <div class="sign_item flex ">
                                    <div class="flex flex_align_baseline flex_align_center">
                                        <div class="sign_name">
                                            {{ formInput.employee_sign }}
                                        </div>
                                        <div class="sign_btn">
                                            <img :src="showImg('employee_sign')" />
                                            <button v-if="!id &&
            !disabledBtn.employee_sign
            " class="btn_primary" @click="
            openSign({
                key: 'employee_sign',
            })
            ">
                                                簽名
                                            </button>
                                            <span v-else></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label>已入廠施工人員</label>
                                <div class="sign_item ">
                                    <div class="flex flex_align_baseline flex_align_center" v-for="(
                                            visitor, index
                                        ) in formInput.visitors">
                                        <div class="sign_name">
                                            {{ visitor.vendor_chinese }} / {{ visitor.name }}
                                        </div>
                                        <div class="sign_btn ">
                                            <img :src="showImg(
            'visitor_sign',
            index
        )
            " />
                                            <button v-if="!id &&
            !disabledBtn.visitor_sign[
            index
            ]
            " class="btn_primary" @click="
            openSign({
                key: 'vistors',
                index: index,
            })
            ">
                                                簽名
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- <template v-else>
                        !---進場員工--
                        !-- <div class="sign_list">
                            <div
                                class="sign_item flex"
                                v-for="(sign, index) in allData.sign_list"
                                :key="index"
                            >
                                <div class="sign_name">{{ sign.name }}</div>
                                <div class="sign_btn">
                                    <img
                                        v-if="sign.img"
                                        :src="transImg(sign.img)"
                                    />
                                </div>
                            </div>
                        </div> -->
                    <!--監工及安全衛生-->
                    <!-- <div class="sign_list">
                            <div class="sign_item">
                                <div>現場監工人員</div>
                                <div class="flex">
                                    <div class="sign_name">
                                        {{ formInput.vendor_sign }}
                                    </div>
                                    <div class="sign_btn">
                                        <img
                                            :src="
                                                transImg(
                                                    allData.vendor_sign
                                                )
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="sign_item">
                                <div>工作場所負責人</div>
                                <div class="flex">
                                    <div class="sign_name">
                                        {{ formInput.employee_sign }}
                                    </div>
                                    <div class="sign_btn">
                                        <img
                                            :src="
                                                transImg(
                                                    allData.employee_sign
                                                )
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <label>現場監工人員</label>
                            <div class="sign_item flex">
                                <div
                                    class="flex flex_align_center"
                                    v-for="(vendor, index) in formInput.vendors"
                                    :key="index"
                                >
                                    <div class="sign_name">
                                        {{ vendor.company_name }} /
                                        {{ vendor.supervisor.name }}
                                    </div>
                                    <div class="sign_btn">
                                        <img
                                            :src="showImg('vendor_sign', index)"
                                            alt=""
                                        />

                                        <button
                                            v-if="
                                                !id &&
                                                !disabledBtn.vendor_sign[index]
                                            "
                                            class="btn_primary"
                                            @click="
                                                openSign({
                                                    key: 'vendor_sign',
                                                    index: index,
                                                })
                                            "
                                        >
                                            簽名
                                        </button>
                                        <span v-else></span>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label>安全衛生管理員</label>
                                <div class="sign_item flex">
                                    <div class="flex flex_align_center">
                                        <div class="sign_name">
                                            {{ formInput.employee_sign }}
                                        </div>
                                        <div class="sign_btn">
                                            <img
                                                :src="showImg('employee_sign')"
                                            />
                                            <button
                                                v-if="
                                                    !id &&
                                                    !disabledBtn.employee_sign
                                                "
                                                class="btn_primary"
                                                @click="
                                                    openSign({
                                                        key: 'employee_sign',
                                                    })
                                                "
                                            >
                                                簽名
                                            </button>
                                            <span v-else></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label>已入廠人員</label>
                                <div class="sign_item flex">
                                <div
                                    class="flex flex_align_center"
                                    v-for="(visitor, index) in formInput.visitors"
                                    :key="index"
                                >
                                    <div class="sign_name">
                                        {{ visitor }}
                                    </div>
                                    <div class="sign_btn">
                                        <img
                                            :src="showImg('visitor_sign', index)"
                                            alt=""
                                        />

                                        <button
                                            v-if="
                                                !id &&
                                                !disabledBtn.visitor_sign[index]
                                            "
                                            class="btn_primary"
                                            @click="
                                                openSign({
                                                    key: 'visitor_sign',
                                                    index: index,
                                                })
                                            "
                                        >
                                            簽名
                                        </button>
                                        <span v-else></span>
                                    </div>
                                </div>
                            </div>
                                 <div class="sign_item flex">
                                    <div
                                        class="flex flex_align_center"
                                        v-for="(
                                            visitor, index
                                        ) in formInput.visitors"
                                    >
                                        <div class="sign_name">
                                        {{ visitor.vendor_chinese }} /
                                            {{ visitor.name }}

                                        </div>
                                        <div class="sign_btn">
                                            <img
                                                :src="
                                                    showImg(
                                                        'visitor_sign',
                                                        index
                                                    )
                                                "
                                            />
                                            <button
                                                v-if="
                                                    !id &&
                                                    !disabledBtn.visitor_sign[
                                                        index
                                                    ]
                                                "
                                                class="btn_primary"
                                                @click="
                                                    openSign({
                                                        key: 'vistors',
                                                        index: index,
                                                    })
                                                "
                                            >
                                                簽名
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </template> -->
                </div>
            </template>
        </div>
        <div class="commit_btn flex" v-if="!id">
            <button class="btn_gray" @click="returnLogin">返回</button>
            <button class="btn_primary" @click="enter">送出</button>
        </div>
    </div>
</template>

<style lang="scss">
.width_220 {
    width: 220px;
}

.paper_popup {
    position: relative;
}

.dailyDanger {
    .multi_navigation {
        margin-top: 25px;
        border-bottom: 1px solid #ccc;

        .item {
            padding: 3px 10px;

            &.check {
                border-bottom: 2px solid var(--mainColor);
            }
        }
    }

    .special_option {
        max-width: 100%;

        p {
            font-size: 13px;
            margin-bottom: 10px;
        }

        .descript {
            margin-top: 5px;

            >div {
                white-space: pre-wrap;
            }
        }

        .checkbox_item {
            display: flex !important;
            align-items: top;
            margin-bottom: 13px;

            h1 {
                font-weight: bold;
            }

            .el-checkbox__input {
                margin-top: 2px;
            }
        }

        label {
            &.is-checked {
                span {
                    color: #409eff;
                    font-weight: bold;
                }
            }
        }

        span {
            color: var(--fontGray);
        }

        .el-checkbox-group {

            // display: flex;
            // flex-wrap: wrap;
            // justify-content: left;
            label {
                display: block;
                font-weight: normal;
            }
        }
    }

    .commit_content {
        padding-top: 10px;
        border-top: 1px dashed #ccc;
        border-bottom: 1px dashed #ccc;
        padding-bottom: 10px;
        font-size: 14px;

        >div {
            margin: 10px 0;
        }
    }
}

.paper_commit {
    .close {
        // position: relative;
        top: 8vh;
        z-index: 99999;
        left: 50%;
        transform: translateX(20vh);
        position: fixed;
        // cursor: pointer;
    }
}

.commit_textarea {
    margin-top: 10px;

    .commit_textarea_item {
        background: #efefef;
        padding: 15px 15px;
        border-radius: 5px;
        margin: 5px 0;
        white-space: pre-wrap;
    }
}

.sign_list {
    .sign_item {
        margin: 10px 0;
        // flex-direction: column;
        height: 100%;

        div {
            margin-bottom: 10px;
            height: 100%;
        }

        .sign_name {
            max-width: 100%;
            height: 100%;
            margin: 0 10px;
        }

        .sign_btn {
            width: 400px;
            height: 100%;

            button {
                margin: 0 10px;
                width: 100px;
            }

            img {
                border: 1px solid #ccc;
                max-width: 250px;
            }
        }
    }
}
</style>
<script>
import mixins from "@/components/mixins.js";
import Options from "@/utils/options";
import Sign from "./SignCanvas";
import axios from "axios";
export default {
    name: "new_paper-toolbox",
    mixins: [mixins],
    data() {
        return {
            allData: [],
            formInput: {
                //date: "",
                name: "",
                area: [],
                vendor: "",
                vendor_sign: null,
                employee_sign: null,
                //原來的sign_img: {},
                sign_img: {
                    employee_sign: null,
                    vendor_sign: [],
                    visitor_sign: [],
                },

                commit_content: "",
                op_id: [],
                // sign_list: [],
                danger_list: [],
                danger_list_other: "",
                protection_list: [],
                protection_list_other: "",
                danger_elemnet: [],
                visitors: [],
            },
            sign_name: null,
            options: {
                application: [],
                op_descript: [
                    {
                        op_id: "1",
                        op_name: "挖掘危險作業",
                        descript: "墜落、火災、爆炸、中毒、缺氧、感電",
                        notice: [
                            "1.施工前應先掌握地下管線位置資訊",
                            "2.施工前應妥為規劃工法",
                            "3.需設立露天開挖作業主管",
                            "4.施工時備至四用氣體偵測器，偵測有無洩漏之餘",
                        ],
                    },
                    {
                        op_id: "2",
                        op_name: "有機溶劑危險作業",
                        descript: "火災、爆炸、吸入、噴濺",
                        notice: [
                            "1.確認有機溶劑作業通風量充足",
                            "2.容易逸散有機溶劑蒸汽之容器均已加蓋",
                            "3.作業人員著戴橡膠手套、護目鏡、防煙霧口罩等個人防護具、需於作業前確認作業物質是否正確。",
                            "4.現場置備ＳＤＳ供作業時或緊急時參考之用。",
                        ],
                    },
                    {
                        op_id: "3",
                        op_name: "吊掛危險作業",
                        descript: "翻覆、吊桿彎曲、物體飛落、感電",
                        notice: [
                            "1.合格人員之操作（操作人員、吊掛人員證書）。",
                            "2.起重機合格證。",
                            "3.不可超過吊掛荷重。",
                            "4.吊具、鋼索、布索檢點。",
                            "5.高壓線防護派人監視。",
                            "6.吊掛作業應設圍籬警示。",
                            "7.嚴禁人員進入吊舉物下方。",
                            "8.提出吊掛作業許可申請。",
                        ],
                    },
                    {
                        op_id: "4",
                        op_name: "局限缺氧空間危險作業",
                        descript: "中毒、缺氧、可燃性氣體",
                        notice: [
                            "1.現場需設置局限空間作業主管。",
                            "2.機械通風。",
                            "3.個人防護器具（呼吸式防護具、安全帶、安全索）。",
                            "4.實施氧氣、硫化氫、一氧化碳、可燃性氣體測定。",
                            "5.持續測定（氧氣、硫化氫、一氧化碳、可燃性氣體濃度）",
                            "6.提出局限空間作許可申請。",
                        ],
                    },
                    {
                        op_id: "5",
                        op_name: "高架危險作業",
                        descript: "跌落、墜落、踏穿、倒塌、物體飛落",
                        notice: [
                            "1.使用安全帶、安全母索、安全帽、符合規定之梯子。",
                            "2.高差超過1.5公尺應設置符合規定之安全上下設備。",
                            "3.施工架頂層應設置90公分以上護欄，並包括上欄杆、中欄杆。",
                            "4.使用A字梯，嚴禁踩在梯頂作業，使用符合規定之A字梯。",
                            "5.工具、材料牢靠固定。",
                            "6.酒醉或有酒醉之虞者、身體虛弱有安全顧慮者不得施工。",
                            "7.於石綿板、鐵皮板、瓦、木板、芧草、塑膠等構築屋頂從事作業時，應於屋架上設置適當強度，且寬度在30公分以上之踏板或裝設安全護網，並設置屋頂作業主管。",
                            "8.提出高架作業許可申請。",
                        ],
                    },
                    {
                        op_id: "6",
                        op_name: "動火危險作業",
                        descript: "灼傷、燃燒、火災、爆炸、輻射危害、切割",
                        notice: [
                            "1.個人防護器具（安全面罩、防護眼鏡及防護手套等）。",
                            "2.滅火器備置。",
                            "3.電焊機金屬外殼接地，備自動電擊防上裝置。",
                            "4.鋼瓶直立固定。",
                            "5.作業前後須作環境確認，避免餘火發生。",
                            "6.附近若有易燃物須清除或備防火毯防護。",
                            "7.使用研磨機、研磨輪，應於每日作業開始前試轉一分鐘以上，研磨輪更換時應先檢 驗有無裂痕，並在防護罩下試轉三分鐘以上。",
                            "8.提出動火許可申請。",
                        ],
                    },
                    {
                        op_id: "7",
                        op_name: "危害物管路拆卸作業",
                        descript: "火災、爆炸、中毒、高溫",
                        notice: [
                            "1.管線拆離前需先進行迫淨的作業，並確定管線內殘餘氣體低於爆炸下限。",
                            "2.非必要時，不得進行動火作業，並需確保施工處沒有火源或熱源的存在。不得已必須施行動火作業時，必須事前申請動火工作許可證，再進行動火作業。",
                            "3.若拆離的管線內原本流通的化學物質屬於毒性化學物質，施行管線拆離之作業人員必須配戴防護具，如防護衣、防毒面罩或手套等等，以保護自身的安全。",
                            "4.除非管線為PVC等不會產生靜電之材質，否則在施行管線拆離作業前，必須先做接地聯結的工作，以避免靜電產生的危害。",
                            "5.管線拆離前，必須確認兩端閥門已緊閉，以確保化學物質不會不斷地流入管線中，而產生洩漏。",
                            "6.管線拆離前，必須先確認管線及其內部之蒸氣溫度，以避免發生被高溫所燙傷的意外事故。",
                        ],
                    },
                    {
                        op_id: "8",
                        op_name: "鑽孔銑洞危險作業",
                        descript: "墜落、化學品接觸/吸入",
                        notice: [
                            "1.	確定鑽孔銑洞位置無管路、配線等危險物。",
                            "2.	施工底層是否使用帆布、水桶防護及導流措施避免污染環境。",
                            "3.	作業前是否已完成申請核准。",
                        ],
                    },
                    {
                        op_id: "9",
                        op_name: "活線危險作業",
                        descript: "感電",
                        notice: [
                            "1.備漏電斷路器。",
                            "2.停電作業須掛牌上鎖。",
                            "3.作業前需確認是否斷電。",
                            "4.復電前需確認有否人員還在作業。",
                            "5.復電前需確認有否人員還在作業。",
                        ],
                    },
                    {
                        op_id: "10",
                        op_name: "屋頂危險作業",
                        descript: "跌落、墜落、物體飛落",
                        notice: [
                            "1.確定有設置防止踏穿之防護措施(安全母索、安全踏板、安全網等)。",
                            "2.確認屋頂作業人員身體狀況良好。",
                            "3.確認人員確實配戴個人防護具(安全帽、背負式安全帶)。",
                            "4.確認該作業有配置屋頂作業主管。",
                            "5.作業前是否已完成申請核准。",
                        ],
                    },
                    {
                        op_id: "11",
                        op_name: "高架地板開口作業",
                        descript: "",
                        notice: [
                            "1.	施工現場依規定架設圍籬及警告標示。",
                            "2.	高架地板下方(如RAP / SFAB)需加設圍籬",
                            "3.	作業現場開口部有監護人員。",
                            "4.	人員管制，非施工人員禁止進入。",
                            "5.	作業前是否已完成申請核准。",
                        ],
                    },
                ],
                op_list: [],
                vendors: [],
            },
            workData: null,
            workData_id: null,
            popupStatus: false,
            popup: null,
            successText: null,
            commitItem: [
                "應依規定配戴適當之防護用具（安全帽、防護手套等）。",
                "作業前使用機具、工具應確實實施點檢，所有捲夾設備嚴禁配戴手套。",
                "工作場所環境維持：禁止嚼檳榔、現場抽煙及攜帶含酒精成分飲料進廠。",
                "抽菸指地點：請於吸菸區吸菸。",
                "化學品放置區：非相關人員禁止靠近。",
                "上下樓梯時要小心，預防滑倒、跌倒，廠區行走注意車輛避免衝撞。",
                "不隨意碰觸廠內電氣設備及操作機台，作業前應知會該單位主管核准後始可作業。",
                "危險機械或設備之操作人員應依法取得合格執照始可操作。",
                "未經許可禁止攜帶攝影器材進入廠區，如需照相，務必經過本廠陪同人員代為申請。",
            ],
            info: [
                "跌、墜落",
                "物體飛落",
                "異物入眼",
                "感電",
                "噪音",
                "與高/低溫接觸",
                "擦、刺、扭、壓、夾、碰撞、割傷",
                "化學品接觸/吸入",
                "火災、爆炸",
                "缺氧危害",
                "其他潛在危害",
                "無",
            ],
            tools: [
                "安全帽",
                "安全鞋",
                "護目鏡",
                "防護面盾",
                "氣體偵測器",
                "呼吸防護器具",
                "聽力保護器具",
                "化學品防護器具",
                "火災預防器具",
                "感電預防器具",
                "缺氧預防器具",
                "墜落防護設備",
                "其他",
                "無需安全防護具",
            ],
            multi_navigation_check: 0,
            visitors: [],
            sign_index: null,
            disabledBtn: {
                employee_sign: null,
                vendor_sign: [],
                visitor_sign: [],
            },
            formDate: "",
        };
    },
    computed: {
        id() {
            return this.$route.query.work_id ? this.$route.query.work_id : null;
        },
        write() {
            //write_work_id代表這張toolbox的id
            return this.$route.query.write_work_id
                ? this.$route.query.write_work_id
                : false;
        },
        transImg() {
            return function (val) {
                return `${this.$http.base.storage}${val}`;
            };
        },
    },
    components: {
        Sign,
    },
    methods: {
        async getData() {
            //原來的 this.$http.api.vendor.getDailyConstruction().then((res) => {
            //   const today = this.$moment().format("YYYY-MM-DD");
            //   this.options.application = res.data.filter((el) => {
            //     return this.$moment(today).isSame(el.date);
            //   });
            // })
            //get sign Data
            //console.log(this.$route.query.write_work_id);
            if (this.$route.query.write_work_id) {
                this.formDate = this.$moment().format("YYYY-MM-DD");
                await this.$http.api.paper
                    .getToolbox(this.$route.query.write_work_id)
                    .then((res) => {
                        //console.log("走write_work_id");
                        //展開資料
                        this.workData = res.data;
                        const haveValue = ["commit_content", "sign_list"];
                        for (const key of haveValue) {
                            const value = this.workData[key];
                            if (value !== null) {
                                if (key === "sign_list") {
                                    this.formInput.sign_img = value;
                                } else {
                                    this.formInput[key] = value;
                                }
                            } else {
                                this.formInput[key] = "";
                            }
                        }
                        // console.log(res.data.visitors);
                        this.formInput.visitors = res.data.visitors;
                    });
                //get FormInput Data
                await this.$http.api.vendor
                    .getNewConstruction("", this.$route.query.new_work_id)
                    .then((res) => {
                        //this.options.application = res.data[0].new_work;
                        this.options.application = res.data;
                        //展開API Data to formInput
                        this.workData_id = this.options.application.id;
                        this.formInput.name = this.options.application.name;
                        this.formInput.area = this.options.application.area;
                        this.formInput.employee_sign =
                            this.options.application.employee.name;
                        this.formInput.vendors =
                            this.options.application.vendors;
                        if (this.is_role !== "vendor" && this.is_role != null) {
                            //處理承攬商及其監工
                            this.options.application.vendors.forEach(
                                (item, index) => {
                                    const new_op_list =
                                        this.options.vendor.find((vendor) => {
                                            return (
                                                vendor.vendor_id ==
                                                item.vendor_id
                                            );
                                        });
                                    item.company_name =
                                        new_op_list.vendor_chinese;
                                }
                            );
                        } else {
                            //處理承攬商及其監工
                            for (
                                let i = 0;
                                i < this.formInput.vendor.length;
                                i++
                            ) {
                                this.formInput.vendors[i].company_name =
                                    this.formInput.vendor[i];
                            }
                        }

                        //依daily date 建立op_list
                        const new_op_list =
                            this.options.application.dailys.find((item) => {
                                //console.log(item);
                                return item.date == this.formDate;
                            });
                        new_op_list.op_id.forEach((item, index) => {
                            const op_list = this.options.op_list.find((op) => {
                                return op.op_id == item;
                            });
                            this.formInput.op_id.push(op_list.op_name);
                        });

                        if (this.workData.sign_list != null) {
                            this.formInput.sign_img = this.workData.sign_list;
                        } else {
                            this.formInput.sign_img = {};
                        }
                    });
            } else {
                //Admin 由新施工單導回工具箱頁面
                //console.log("work_id:", this.$route.query.work_id);
                await this.$http.api.paper
                    .getToolbox(this.$route.query.work_id)
                    .then((res) => {
                        //展開資料
                        this.allData = res.data;
                        this.formInput.visitors = res.data.visitors;
                        //處理Api回傳的資料為null的值
                        const haveValue = [
                            "commit_content",
                            "sign_list",
                            "danger_list",
                            "danger_elemnet",
                            "protection_list",
                            "protection_list_other",
                        ];
                        for (const key of haveValue) {
                            const value = this.allData[key];
                            if (value !== null) {
                                if (key === "sign_list") {
                                    this.formInput.sign_img = value;
                                } else {
                                    this.formInput[key] = value;
                                }
                            }
                        }
                    });
                //get FormInput Data
                await this.$http.api.vendor
                    .getNewConstruction("", this.$route.query.new_work_id)
                    .then((res) => {
                        this.options.application = res.data;
                        this.formInput.name = this.options.application.name;
                        this.formInput.area = this.options.application.area;
                        this.formInput.employee_sign =
                            this.options.application.employee.name;
                        this.formInput.vendors =
                            this.options.application.vendors;

                        if (this.is_role !== "vendor" && this.is_role != null) {
                            this.formInput.vendor=this.options.application.vendors.map((item) => {return item.company_name});
                            //處理承攬商及其監工
                            this.options.application.vendors.forEach(
                                (item, index) => {
                                    const new_op_list =
                                        this.options.vendor.find((vendor) => {
                                            return (
                                                vendor.vendor_id ==
                                                item.vendor_id
                                            );
                                        });
                                    item.company_name =
                                        new_op_list.vendor_chinese;
                                }
                            );
                        } else {
                            //處理承攬商及其監工
                            for (
                                let i = 0;
                                i < this.formInput.vendor.length;
                                i++
                            ) {
                                console.log(i);
                                this.formInput.vendors[i].company_name =
                                    this.formInput.vendor[i];
                            }
                        }
                        //處理daily_toolboxData(以this.$route.query.work_id抓出對應toolbox 的日期)
                        const dailyData = this.options.application.dailys.find(
                            (item) => {
                                return item.id == this.$route.query.toolbox_id;
                            }
                        );

                        this.allData.date = dailyData.date;
                        this.formInput.op_id = dailyData.op_id;

                        //處理op的id 轉換成op名稱
                        this.formInput.op_id.forEach((item, index) => {
                            const op_item = this.options.op_list.find((op) => {
                                return op.op_id == item;
                            });

                            this.formInput.op_id[index] = op_item.op_name;
                        });
                        const vendor=new Set(this.allData.visitors.map((el)=>{
                            return el.vendor_chinese;
                        }));
                        this.formInput.vendor = Array.from(vendor);
                    });
                //get
            }
            const haveValue = [
                "commit_content",
                "sign_list",
                "danger_elemnet",
                "danger_list",
                "danger_list_other",
                "protection_list",
                "protection_list_other",
            ];
            for (const key of haveValue) {
                let value;
                if (this.$route.query.write_work_id) {
                    value = this.workData[key];
                } else {
                    value = this.allData[key];
                }
                if (value !== null) {
                    if (key === "sign_list") {
                        this.formInput.sign_img = value;
                    } else {
                        this.formInput[key] = value;
                    }
                } else {
                    //console.log(value);
                }
            }
            //移除入廠人員清單中的監工
            if (this.formInput.visitors.length > 0) {
                let item_index;
                this.formInput.vendors.forEach((item) => {
                    item_index = this.formInput.visitors.findIndex((el) => {
                        return item.supervisor.name === el.name;
                    });
                    if(item_index!==-1){
                        this.formInput.visitors.splice(item_index, 1);
                    }
                });
            }
        },
        getTodayNewWork() {
            this.$http.api.vendor.getNewDailyConstruction().then((res) => {

                const data = res.data;
                // console.log(data);
                const today_work = data.find((item) => {
                    // console.log(item.new_work.id);
                    // console.log(this.$route.query.new_work_id);
                    return item.new_work.id == this.$route.query.new_work_id;
                });
                this.formInput.vendor = today_work.vendor_chinese;
                this.formInput.danger_elemnet = today_work.op_list;
                // today_work.op_list.forEach((item) => {
                //     const today_op_list = this.options.op_list.filter((op) => {
                //         return op.op_name === item;
                //     });


                //     this.formInput.danger_elemnet.push(today_op_list[0].op_id)
                // });

            });
        },
        // getVendorData(vendor_id, index) {
        // this.$http.api.vendor
        //         .vendorBasisGet(vendor_id)
        //         .then((res) => {
        //             console.log("get Vendor_chinese");
        //             this.formInput.vendors[index]["company_name"] =
        //                 res.data.vendor_chinese;
        //         });
        // },
        async handlerID(e) {
            // this.workData=e;
            const area_data = await Options.getArea();
            this.formInput.area = area_data.filter((el) => {
                return e.area_id.includes(el.id);
            });
            const op = await Options.getSpecialOperation();
            this.formInput.op_id = op.filter((el) => {
                return e.op_id.includes(el.op_id);
            });
            this.formInput.sign_list = e.employees
                .map((el) => {
                    return { name: el.name };
                })
                .filter((el) => {
                    return e.supervisor.name !== el.name;
                });
            //確認key
            this.formInput.vendor = e.vendor.vendor_chinese;
            this.formInput.vendor_sign = e.supervisor.name;
            this.formInput.employee_sign = e.application.employee.name;
        },
        //原來的 openSign({ key }) {
        //     this.popup = "sign";
        //     this.sign_name = key;
        //     this.popupStatus = true;
        // },
        openSign({ key, index }) {
            //console.log(key, index);
            this.popup = "sign";
            if (key == "employee_sign") {
                this.sign_name = key;
            } else if (key == "vendor_sign") {
                this.sign_name = "vendor_sign";
                this.sign_index = index;
            } else {
                this.sign_name = "visitor_sign";
                this.sign_index = index;
            }
            this.popupStatus = true;
        },
        closeSign() {
            this.popupStatus = false;
        },
        transfromIMG(base64Img, name, index) {
            //原來的
            // this.closeSign();
            // console.log(name);
            // this.formInput.sign_img[name] = base64Img;
            this.closeSign();
            if (name === "employee_sign") {
                this.formInput.sign_img[name] = base64Img;
            } else if (name === "vendor_sign") {
                if (!this.formInput.sign_img[name]) {
                    this.$set(this.formInput.sign_img, [name], {});
                }
                this.formInput.sign_img[name][index] = base64Img;
            } else {
                if (!this.formInput.sign_img[name]) {
                    this.$set(this.formInput.sign_img, [name], {});
                }
                this.formInput.sign_img[name][index] = base64Img;
            }
        },
        enter() {
            //檢查危害告知與防護器具至少填寫一項
            const check_input = ["danger_list", "protection_list"];
            check_input.forEach((item) => {
                if (this.formInput[item].length === 0) {
                    if (item == "danger_list") {
                        alert("請檢查必填的危害告知");
                        const danger_Anchor =
                            document.querySelector("#danger_list");
                        document.documentElement.scrollTop =
                            danger_Anchor.offsetTop - 80;
                    } else {
                        alert("請檢查必填的防護器具");
                        const protection_Anchor =
                            document.querySelector("#protection_list");
                        document.documentElement.scrollTop =
                            protection_Anchor.offsetTop - 80;
                    }
                } else {
                    const data = {
                        danger_list: this.formInput.danger_list,
                        danger_list_other: this.formInput.danger_list_other,
                        protection_list: this.formInput.protection_list,
                        protection_list_other:
                            this.formInput.protection_list_other,
                        danger_elemnet: this.formInput.danger_elemnet,
                        sign_list: this.formInput.sign_img,
                        commit_content: this.formInput.commit_content,
                    };
                    console.log(data);
                    const id = this.$route.query.write_work_id;
                    this.$http.api.paper
                        .putToolbox(id, data)
                        .then((res) => {
                            this.popupStatus = true;
                            this.successText = "成功";
                            this.popup = "success";
                            //init
                            this.workData = null;
                            this.formInput.danger_list = [];
                            this.formInput.danger_list_other = "";
                            this.formInput.protection_list = [];
                            this.formInput.protection_list_other = "";
                            this.formInput.danger_elemnet = "";
                            this.formInput.sign_img = {};
                            this.formInput.commit_content = null;
                        })
                        .catch((error) => {
                            this.popupStatus = true;
                            this.popup = "error";
                            this.successText = `系統錯誤`;
                        });
                }
            });

            // this.$http.api.paper
            //     .toolbox({
            //         work_id: this.workData.id,
            //         danger_list: this.formInput.danger_list,
            //         danger_list_other: this.formInput.danger_list_other,
            //         protection_list: this.formInput.protection_list,
            //         protection_list_other: this.formInput.protection_list_other,
            //         danger_elemnet: this.formInput.danger_elemnet,
            //         sign_list: this.formInput.sign_list,
            //         employee_sign: this.formInput.sign_img.employee_sign,
            //         vendor_sign: this.formInput.sign_img.vendor_sign,
            //         commit_content: this.formInput.commit_content,
            //     })
            //     .then((res) => {
            //         this.popupStatus = true;
            //         this.successText = "成功";
            //         this.popup = "success";
            //         //init
            //         this.workData = null;
            //         this.formInput.sign_list = [];
            //         this.formInput.danger_list = [];
            //         this.formInput.danger_list_other = "";
            //         this.formInput.protection_list = [];
            //         this.formInput.protection_list_other = "";
            //         this.formInput.danger_elemnet = "";
            //         this.formInput.sign_img = {};
            //         this.formInput.commit_content = null;
            //     })
            //     .catch((error) => {
            //         this.popupStatus = true;
            //         this.popup = "error";
            //         this.successText = `系統錯誤`;
            //     });
        },
        poupupEnter() {
            this.popupStatus = false;
            this.returnLogin();
        },
        workDate(item, index) {
            this.multi_navigation_check = index;
        },
        showImg(sign, index) {
            //確認能取到this.formInput.sign_img[sign]有東西(非null)
            if (this.formInput.sign_img[sign]) {
                //判斷sign是不是employee_sign
                if (sign === "employee_sign") {
                    const url = this.formInput.sign_img[sign].endsWith(".png");
                    if (!url) {
                        return this.formInput.sign_img[sign];
                    } else {
                        //console.log('return error');
                        this.disabledBtn[sign] = true;
                        return `${this.$http.base.storage}${this.formInput.sign_img[sign]}`;
                    }
                } else {
                    //確認能取到this.formInput.sign_img[sign][index]有東西(非null)
                    if (this.formInput.sign_img[sign][index]) {
                        const url =
                            this.formInput.sign_img[sign][index].endsWith(
                                ".png"
                            );
                        //確認圖片url的結尾是不是.png
                        if (!url) {
                            //代表為新增簽名
                            return this.formInput.sign_img[sign][index];
                        } else {
                            //代表為新增簽名
                            this.disabledBtn[sign][index] = true;
                            return `${this.$http.base.storage}${this.formInput.sign_img[sign][index]}`;
                        }
                    } else {
                        return "";
                    }
                }
            } else {
                return "";
            }
        },
    },
    async created() {
        if (this.is_role !== "vendor" && this.is_role != null) {
            //console.log('is_role:', this.is_role);
            this.options.vendor = await Options.getVendor();
        } else {
            await this.getTodayNewWork();
        }
        //this.getOneData();
        this.options.op_list = await Options.getSpecialOperation();
        await this.getData();
    },
};
</script>
